import { render, staticRenderFns } from "./ProductBulkUpload.vue?vue&type=template&id=ba2a1f48&"
import script from "./ProductBulkUpload.vue?vue&type=script&lang=js&"
export * from "./ProductBulkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports